import React from 'react'
import LuckysevanB from "../../../../assets/Sample/Lucky-7-B.png"
import LuckySevanA from "../../../../assets/Sample/Lucky-7-A.png"

export default function Lucky7() {
  return (
<div className="tab-content">
  <div className="tab-pane active" id="all-casino">
    <div className="casino-list">
      {/* <div className="casino-list-item">
        <a href="/casino/lucky15">
          <div
            className="casino-list-item-banner"
            style={{
              backgroundImage:
                'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky15.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")'
            }}
          />
        </a>
      </div> */}
      <div className="casino-list-item">
        <a href="/casino/lucky7">
          <div
            className="casino-list-item-banner"
            style={{
              backgroundImage:
                `url(${LuckySevanA}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
            }}
          />
        </a>
      </div>
      <div className="casino-list-item">
        <a href="/casino/lucky7eu">
          <div
            className="casino-list-item-banner"
            style={{
              backgroundImage:
                `url(${LuckysevanB}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
            }}
          />
        </a>
      </div>
      {/* <div className="casino-list-item">
        <a href="/casino/lucky7eu2">
          <div
            className="casino-list-item-banner"
            style={{
              backgroundImage:
                'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky7eu2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")'
            }}
          />
        </a>
      </div> */}
    </div>
  </div>
</div>
  )
}
